<template>
  <teleport to="body">
    <div
      ref="modalRoot"
      class="modal fade"
      :id="id"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog custom-gfb-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-26-900">{{ title }}</h5>
            <button
              type="button"
              class="close"
              @click="handleCancel"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p v-if="description" class="my-4 ml-4">
              {{ description }}
            </p>

            <div class="modal-body-content">
              <slot name="input"></slot>

              <div class="action-btns" v-if="showActions">
                <DefaultButton
                  :btnType="['cancel-btn']"
                  v-if="showCancel"
                  :labelText="'Cancel'"
                  @click="handleCancel"
                />
                <DefaultButton
                  :btnType="btnClasses"
                  :labelText="confirmLabel"
                  @click="handleConfirm"
                  :disabled="disableConfirmButton"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import DefaultButton from "@/components/DefaultButton"
export default {
  name: "default-modal",
  components: { DefaultButton },
  props: {
    title: {
      type: String,
      default: "Modal header",
    },
    description: {
      type: String,
      default: "Modal description",
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    disableConfirmButton: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "common-modal",
    },
    btnClasses: {
      type: Array,
    },
    confirmLabel: {
      type: String,
      default: "Confirm",
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$refs.modalRoot?.addEventListener(
      "hidden.bs.modal",
      this.onModalHidden
    )
  },
  beforeUnmount() {
    this.$refs.modalRoot?.removeEventListener(
      "hidden.bs.modal",
      this.onModalHidden
    )
  },
  methods: {
    handleConfirm() {
      this.$emit("onConfirm")
    },
    handleCancel() {
      this.$bvModal.hide(this.id)
      this.$emit("onCancel")
    },
    onModalHidden() {
      // Only emit if parent listens
      this.$emit("onClosed")
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-body-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.action-btns {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}
</style>
